import React from 'react';
import SlackMessage from './slack/SlackMessage';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';

const CONTENT_FRAGMENT = gql(`
  fragment SlackSearchResultContent_content on MentionContentSlack {
    previous {
      ...SlackMessage_message
    }
    message {
      ...SlackMessage_message
    }
    next {
      ...SlackMessage_message
    }
  }
`);

interface SlackSearchResultContentProps {
  content: DocumentType<typeof CONTENT_FRAGMENT>;
}

const SlackSearchResultContent = ({
  content: { previous, message, next },
}: SlackSearchResultContentProps) => (
  <>
    {previous && <SlackMessage message={previous} />}
    {message && <SlackMessage message={message} />}
    {next && <SlackMessage message={next} />}
  </>
);

export default SlackSearchResultContent;
